module.exports = __webpack_public_path__ + "static/img/tool1.5dad5f49.png";